module.exports = __webpack_public_path__ + "img/code-snippet-02.a5d91c69.svg";